import React from "react";
import { Helmet } from "react-helmet";
import Breadcrumb from "../../shared/breadcrumb/Breadcrumb";
import { useTranslation } from "react-i18next";
import ToolSolutions from "../../components/tool-solutions/ToolSolutions";

function ToolSolutionsPage({ setShow }) {
  const { t } = useTranslation();
  return (
    <>
      <Helmet>
        <title>Tool Solutions | GGAS</title>
        <meta name="keyword" content="GGAS" />
        <meta name="description" content="GGAS" />
      </Helmet>
      <Breadcrumb title={"Tool Solutions"} t={t} />
      <ToolSolutions />
    </>
  );
}

export default ToolSolutionsPage;
